import React from 'react';

export default function Avatar({image, imageClass}) {
  const storage_url = process.env.REACT_APP_STORAGE_URL;
  return (
    <img src={image ? storage_url+image : '/images/avatar.png'} className={`avatar ${imageClass}`} alt='' />
  )
}
